import { Model } from "@/models/model"

export class ProjectValue extends Model
   constructor: (data, disableTypes) ->
      assertArgs(arguments, optional(Object), optional(Boolean))
      data = {} unless data?
      super(data)
      disableTypes = false unless disableTypes?
      unless disableTypes
         assertOfType(data.name, String)
         assertOfType(data.value, [String, Number, Boolean, Date])

      ###------------------------------------
         Model ID
      ------------------------------------###
      @id = data.id

      ###------------------------------------
         Knockout Observables
      ------------------------------------###
      @name = ko.observable(data.name)
      @value = ko.observable(data.value)

